import React from 'react';

import { StringInputProps } from './index.types';
import { StringInputView } from './index.view';

export function StringInput(props: StringInputProps) {
  return <StringInputView {...props} />;
}

export default StringInput;
export type { StringInputProps } from './index.types';
